import { Col, Divider } from 'antd';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { LinkComponent } from 'baseComponents/LinkComponent';
import { TextComponent } from 'baseComponents/TextComponent';
import { ScreenWrapperComponent } from 'components/layouts/ScreenWrapperComponent';
import { HELP_SCREEN } from 'constants/enums/help-screen';
import 'screens/HelpScreen/helpScreen.scss';

export const HelpScreen = () => {
  return (
    <ScreenWrapperComponent>
      <Col
        lg={{ pull: 6, push: 6, span: 12 }}
        md={{ pull: 1, push: 1, span: 22 }}
        className='help-screen-wrapper'
      >
        <TextComponent size='title-size' text={HELP_SCREEN.HELP_SECTION} />
        <TextComponent size='large' text={HELP_SCREEN.USER_GUIDE} />
        <ButtonComponent
          label={HELP_SCREEN.HERE}
          target='_blank'
          appereance='primary'
          size='middle'
          style={{
            borderRadius: '9999px',
          }}
          href='https://pdms.papajohns.co.uk/file-uploads/comms/images/User%20Guide_SMS_PUSH_1.0_12022026153624.pdf'
        />
        <Divider />
        <TextComponent size='large' text={HELP_SCREEN.TRAINING_VIDEO} />

        <iframe
          src='https://www.youtube.com/embed/vBPYlhJttog'
          title={HELP_SCREEN.TRAINING_VIDEO}
        ></iframe>
        <Divider />

        <p>
          <TextComponent
            size='middle-large'
            type='span'
            text={HELP_SCREEN.IDENTIFY_ISSUES}
          />{' '}
          <LinkComponent
            href='mailto:lsmdealrequests@papajohns.co.uk'
            label='lsmdealrequests@papajohns.co.uk'
          />
        </p>
      </Col>
    </ScreenWrapperComponent>
  );
};
